<template>
  <v-layout column>
    <v-card max-width="350" flat outlined>
      <v-card-text>
        <TimeClock @change="onTimeClockChange"></TimeClock>
      </v-card-text>
    </v-card>
    <v-toolbar flat>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          icon
          :disabled="loading"
          @click="fetchItems"
        >
        <v-icon>mdi-cached</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items-per-page="-1"
      :items="itemsWithDurations"
      :loading="loading"
      :footer-props="{'items-per-page-options': [100, 500, 1000, -1]}"
      fixed-header
      height="calc(100vh - 520px)"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.employee.first_name + " " + props.item.employee.last_name }}</td>
          <td>{{ props.item.start_time | formatDateTime}}</td>
          <td>{{ props.item.end_time | formatDateTime}}</td>
          <td>{{ props.item.duration | formatTimeStringDuration }}</td>
          <td>{{ props.item.pause_duration | formatTimeStringDuration }}</td>
          <td>{{ props.item.comment }}</td>
          <td class="text-right">
            <v-btn
              icon
              title="Stundeneintrag erstellen"
              :disabled="props.item.end_time === null"
              @click="createLogFromEntry(props.item)"
            >
              <v-icon small>
                mdi-calendar-clock
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <span>Keine Daten.</span>
      </template>
    </v-data-table>

    <v-dialog
      v-model="showLogEdit"
      :max-width="dialogWidth"
      persistent
      >
    <Edit
        :log="log"
        @saved="showLogEdit=false"
        ref="edit"
        flat
        hide-actions
      />
       <v-toolbar flat>
      <v-spacer />
      <v-toolbar-items>
        <v-btn text @click="showLogEdit=false"> Abbrechen </v-btn>
        <v-btn text @click="submit"> Speichern </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    </v-dialog>

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { api, endpoints } from '@/api'

import Edit from './logs/Edit'

import {dialogWidth} from './utils/sizes'

import TimeClock from './timeclock/TimeClock'
import moment from 'moment'

import {formatTimeStringDuration} from '../filters/Duration'
import {formatTime, formatDateTime} from '../filters/Time'

export default {
  metaInfo: {
    title: "Stechuhr",
  },
  components: {
    TimeClock,
    Edit
  },
  data () {
    return {
      loading: false,
      items: [],
      headers: [
        { text: "Name", value: "employee.first_name", sortable: false},
        { text: "Startzeitpunkt", value: "start_time", sortable: false, filter: formatDateTime},
        { text: "Endzeitpunkt", value: "end_time", sortable: false },
        { text: "Dauer", value: "", sortable: false },
        { text: "Pausen", value: "pauses", sortable: false},
        { text: "Bemerkung", value: "comment", sortable: false },
        { text: "Aktion", value: "id", sortable: false, class: "text-right" },
      ],
      errors: {},
      showLogEdit: false,
      log: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedEmployees',
      'selectedPeriod',
      'selectedTenant',
    ]),
    filters () {
      if (this.selectedTenant === null) {
        return null
      }
      let r = {
        tenant: this.selectedTenant,
        start_time__date__gte: this.selectedPeriod.start.format("YYYY-MM-DD"),
        end_time__date__lte: this.selectedPeriod.end.format("YYYY-MM-DD"),
        end_time_null: false
      }
      if (this.selectedEmployees.length > 0) {
        r.employee__in = [...this.selectedEmployees.map(i => i.id)]
      }
      return r
    },
    dialogWidth: dialogWidth,
    itemsWithDurations: function () {
      return this.items.map(item => {
        let duration = 0
        let pauseDuration = 0

        if (item.end_time) {
          pauseDuration = item.pauses.reduce((accumulator, pauseItem) => {
              if (!pauseItem.end_time) {
                return accumulator
              }
              let pauseStart = moment(pauseItem.start_time)
              let pauseEnd = moment(pauseItem.end_time)
              return accumulator + Math.floor(moment.duration(pauseEnd.diff(pauseStart)).asMinutes())
          }, 0.0)

          let diff = moment(item.end_time).diff(moment(item.start_time))
          duration = Math.floor(moment.duration(diff).asMinutes()) - pauseDuration
        }
        return {
          ...item,
          duration: duration,
          pause_duration: pauseDuration
        }
      })
    }
  },
  methods: {
    async fetchItems () {
      this.loading = true
      this.errors.unknown = ""
      try {
        const r = await api(endpoints.fetch_timeclock(), this.filters, {method: 'GET'})
        if (r.ok) {
          const d = await r.json()
          this.items.splice(0, this.items.length, ...d)
        } else {
          this.items.splice(0)
          this.errors.unknown = (await r.json()).detail
        }
      } catch (err) {
        console.log(err)
        this.items.splice(0)
        this.errors.unknown = err.message
      } finally {
        this.loading = false
      }
    },
    onTimeClockChange () {
      this.fetchItems()
    },
    createLogFromEntry (entry) {
      this.log = {
          taskday: moment(entry.end_time),
          description: entry.comment,
          journey: 0.0,
          place: "",
          taskduration: entry.duration,
          journey_duration: 0.0,
          additional_meal_allowance: 0.0,
          project: null,
          employee: entry.employee,
          operation: null,
      }
      this.showLogEdit = true
    },
    submit () {
      this.$refs.edit.submit()
    }
  },
  watch: {
    filters: {
      handler () {
        this.fetchItems()
      },
      immediate: true,
      deep: true,
    },
  },
  filters: {
    formatDateTime: (value) => value ? formatDateTime(value) : "",
    formatTimeStringDuration: formatTimeStringDuration,
  },
}
</script>

<style lang="scss">
</style>
